import _ from 'underscore';

/**
 * Handles competition UI interactions, such as changing cards,
 * handling user input, and integrating with external Fancybox modal.
 */
app.components.competition = {
    /**
     * Checks if the competition block exists on the page.
     * @returns {boolean}
     */
    onReady: function () {
        return $('.competition').length > 0;
    },

    /**
     * Updates the main question card based on a given template ID.
     * @param {number|string} template - The template ID to switch to.
     */
    changeCard: function (template) {
        const id = parseInt(template);
        if (!id) return;

        const $card = $('.card--question').eq(0);
        const question = competition_cards.find(card => card.template_id === id);

        if (!question) return;

        $card.attr('data-template', id);
        $('.text', $card).html(question.post_title);
    },

    /**
     * Sets up all required event listeners for competition interactions.
     */
    addListener: function () {
        const self = this;
        const $competitionContainer = $('#competition');

        function flipCard() {
            const $card = $('.card--question').eq(0);
            $card.addClass('flip');

            function rotateAfter(el) {
                if (!el.dataset.rotation) {
                    el.dataset.rotation = 0;
                }
                el.dataset.rotation = parseInt(el.dataset.rotation) + 360;
                el.style.setProperty('--rotation', el.dataset.rotation + 'deg');
                el.classList.add('rotated');
            }

            rotateAfter($('.competition__question__change')[0]);

            setTimeout(() => {
                self.next_card = _.shuffle(competition_cards)[0];
                self.changeCard(self.next_card.template_id);
                $card.removeClass('flip');
            }, 500);
        }

        async function openFancyboxModal() {
            const answer = $('.placeholder', $competitionContainer).text();
            const template = $('.card--question').attr('data-template');
            let url;

            if (wpml_current_language === 'de') {
                url = `${competition_url}?ajax=1&wpf3856_7=${answer}&wpf3856_6=${template}`;
            }

            if (wpml_current_language === 'it') {
                url = `${competition_url}?ajax=1&wpf3859_7=${answer}&wpf3859_6=${template}`;
            }

            if (wpml_current_language === 'fr') {
                url = `${competition_url}?ajax=1&wpf2633_7=${answer}&wpf2633_6=${template}`;
            }

            if (!template || !answer || !url) {
                console.error('Missing template or answer for Fancybox URL');
                return;
            }

            try {
                const Fancyapps = await import('@fancyapps/ui');
                await import('@fancyapps/ui/dist/fancybox/fancybox.css');

                Fancyapps.Fancybox.show([
                    {
                        src: url,
                        type: 'ajax'
                    }
                ], {
                    on: {
                        done: () => {
                            const container = $('.fancybox__content');
                            $('[data-name="shortcode"]', container).html($('card-component.card--question')[0].outerHTML);
                            app.components.form.addListener(container);
                            wpforms.ready();
                        }
                    }
                });

            } catch (error) {
                console.error('Error loading modules:', error)
            }
        }

        $('.competition__question__change', $competitionContainer)
            .on('click', flipCard)
            .trigger('click');

        $('.competition__question .back', $competitionContainer).on('click', () => {
            self.changeCard($('.competition .card.card--question').attr('data-template'));
            $('html.competition--active').removeClass('competition--active');
            return false;
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('html.competition--active .competition .card--question').length) {
                $('.competition__question .back', $competitionContainer).trigger('click');
            }
        });

        $('.competition__question .forward', $competitionContainer).on('click', () => {
            openFancyboxModal();
            return false;
        });

        $('.competition__answers .card--answer', $competitionContainer).on('click', function () {
            const $card = $(this);
            $('html').addClass('competition--active');
            $('.competition__answers .card--answer').removeClass('active');
            $card.addClass('active');

            const $question = $('.card--question').eq(0);
            $('.placeholder', $question).text($('.text', $card).text());
            return false;
        });

        $('.cards .card__choose').on('click', function () {
            const template = $(this).closest('.card').data('template');
            self.changeCard(template);
            $('#main-section-0')[0].scrollIntoView();
            return false;
        });

        $('.card__input', $competitionContainer).on('input', function () {
            $('.placeholder', $competitionContainer).text($(this).val());
        });
    }
};
